module.exports = __webpack_public_path__ + "img/huaweip6.eda615d9.png";